import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({

  zoomContainer: {
    width: '100%',
    height: 'calc(100vh - 72px)',
    marginTop: 72,
    overflow: 'hidden',
    cursor: 'grab',
    position: 'relative',
    backgroundColor: '#f9f9f9', // Fundo opcional

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  zoomContent: {
    width: '100%',
    transformOrigin: 'center', // Define o ponto de zoom como o centro
    transition: 'transform 0.1s ease',
    position: 'absolute',

    [theme.breakpoints.down('sm')]: {
      width: 'unset',
    },

  },

  noParentsContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 72,
    padding: 16,
    height: '100%',

    "& span": {
      fontSize: 20,
      color: '#000',
    }
  },


  genealogicalDiagramContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    "@media (max-width:862px)": {
      minWidth: 450,
    }

  },


  genealogicalDiagramHieraqyContainer: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',

    "@media (max-width:862px)": {
      transform: 'scale(0.7)'
    }
    // transform: 'scale(0.8)', // Reduz em 20%
    // transformOrigin: 'center center', // Define o ponto de origem da transformação
  },

  genealogicalDiagramHieraqyComponents: {
    width: '100%  !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    position: 'absolute',
    top: '-80px',
    transform: 'translateX(-2%)'
  },

  genealogicalDiagramHieraqyPaternalGrandparentsComponents: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    position: 'absolute',
    top: '-287px',
    transform: 'translateX(-46%)'
  },

  genealogicalDiagramPaternalGrandparentsComponents: {
    zIndex: 1,
    position: 'absolute',

    width: '100%',
    maxWidth: 376,
    height: 50,
    border: `solid 1px ${theme.palette.primary.main}`,
    borderBottomLeftRadius: 35,
    borderBottomRightRadius: 35,
    borderTop: 'none',


    '& div:nth-child(1)': {
      top: "-210%",
      left: "-34%",

    },
    '& div:nth-child(4)': {
      top: "-210%",
      left: "66%",
    },
  },




  genealogicalDiagramHieraqyMaternalGrandparentsComponents: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    position: 'absolute',
    top: '-287px',
    transform: 'translateX(33%)',

    "@media (max-width:862px)": {
      top: '-450px',
    }

  },

  genealogicalDiagramMaternalGrandparentsComponents: {
    zIndex: 1,
    position: 'absolute',

    width: '100%',
    maxWidth: 376,
    height: 50,
    border: `solid 1px ${theme.palette.primary.main}`,
    borderBottomLeftRadius: 35,
    borderBottomRightRadius: 35,
    borderTop: 'none',


    '& div:nth-child(1)': {
      top: "-210%",
      left: "-34%",

    },
    '& div:nth-child(4)': {
      top: "-210%",
      left: "66%",
    },
  },




  genealogicalDiagramMainCard: {
    width: '100%',
    position: 'relative',

    "&::after": {
      position: "relative",
      bottom: 31,
      transform: 'translateX(-1197%)',
      content: '""',
      width: 10,
      height: 7,
      borderRadius: "50%",
      border: `solid 1px ${theme.palette.primary.main}`,
      backgroundColor: "#fff"
    },
  },


  expandHieraqyButton: {

  },

  genealogicalDiagramComponents: {
    zIndex: 1,
    position: 'absolute',

    width: '100%',
    maxWidth: 376,
    height: 50,
    border: `solid 1px ${theme.palette.primary.main}`,
    borderBottomLeftRadius: 35,
    borderBottomRightRadius: 35,
    borderTop: 'none',


    '& div:nth-child(1)': {
      top: "-210%",
      left: "-34%",

    },
    '& div:nth-child(4)': {
      top: "-210%",
      left: "66%",
    },
  },


  genealogicalDiagramComponentsWithParents: {
    maxWidth: 550,

    '& div:nth-child(1)': {
      left: "-22%",
    },

    '& span:nth-child(3)': {
      left: "31%",
    },

    '& div:nth-child(4)': {
      left: "78%",

    },
  },



  genealogicalDiagramCard: {
    zIndex: 2,
    position: 'absolute',


    "&::after": {
      position: "relative",
      bottom: -73,
      transform: 'translateX(-1027%)',
      content: '""',
      width: 12,
      height: 9,
      borderRadius: "50%",
      border: `solid 1px ${theme.palette.primary.main}`,
      backgroundColor: "#fff"
    }

  },


  genealogicalDiagramGrauFamilly: {
    position: 'absolute',
    left: '44%',
    top: '-104%',
    fontSize: 14,
    letterSpacing: 2,
    color: '#858585',
    textTransform: 'uppercase'
  },

  genealogicalDiagramGrauMontaType: {
    position: 'absolute',
    left: '23%',
    top: '68%',
    fontSize: 14,
    letterSpacing: 2,
    color: '#000',
    border: `solid 1px #858585`,
    borderRadius: 4,
    backgroundColor: "#fff",
    textTransform: 'uppercase',
    padding: '12px 18px',
    maxHeight: 37,


    "&::after": {
      position: "relative",
      bottom: -9,
      left: "50%",
      display: "block",
      content: '""',
      width: 1,
      height: 38,
      backgroundColor: ` ${theme.palette.primary.main}`,
    },
  },

  genealogicalDiagramGrauMontaTypeMobile: {

    "&::after": {
      "@media (max-width:862px)": {
        height: "202px !important",
      }
    }

  }



}))
